import React from 'react';
import { AgeVerification } from './components/AgeVerification';
import './App.css';

function App() {
  return (
    <div className="App">
      <AgeVerification onlyFirstVisit={true} minimumAge={18} />
    </div>
  );
}

export default App;
